import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, Radio, RadioGroup, Box } from "@mui/material";
import { colors, fonts, shadows } from "../../../theme/theme";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    color: colors.primary,
    boxShadow: shadows.modal,
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  fontFamily: fonts.gotham,
  fontSize: "24px",
  color: colors.primary,
});

export const StyledRadio = styled(Radio)({
  "&.Mui-checked": {
    color: colors.primary,
  },
});

export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledActionsWrapper = styled(Box)(({ theme }) => ({
  borderTop: "1px solid #492A1824",
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
  width: "100%",
}));

export const LESSON_INPUT_PROPS = {
  width: "100%",
  bR: "10px",
  color: colors.primary,
};
